import { Reveal } from "./Reveal";

export const SectionHeading = ({ eyebrow, title, subtitle, align = "left", id }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <Reveal>
        <p className="eyebrow mb-5">{eyebrow}</p>
      </Reveal>
    )}
    <Reveal delay={0.05}>
      <h2 id={id} className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.08] text-white">
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.1}>
        <p className="mt-5 text-base md:text-lg text-slate-400 leading-relaxed">{subtitle}</p>
      </Reveal>
    )}
  </div>
);
